import { Component, Input, OnInit } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

import { CheckPermissionsPipe } from '../../../pipes/check-permissions/check-permisions.pipe';
import { TabPermissions } from '../../../types/tab-permission.type';

@Component({
  selector: 'acp-tax-certification-tab-dropdown, [acp-tax-certification-tab-dropdown]',
  templateUrl: './tax-certification-tab-dropdown.component.html',
  imports: [RouterLink, RouterLinkActive, CheckPermissionsPipe],
})
export class TaxCertificationTabDropdownComponent implements OnInit {
  @Input() taxCertTabPermissions: TabPermissions = {};

  ngOnInit(): void {}
}
